module.exports = __webpack_public_path__ + "img/dbapp_xxdr.8bb5a958.png";